import React from "react";

import { SystemUserUiSettings } from "../../../../app/modules/SystemUser/pages/_redux/system-user-childs/SystemUserUiSettings";
export const UserChildsLoginPage = (props) => {
  let userType = props.match.params.userType;

  let systemUserUiSettings = new SystemUserUiSettings();

  if (userType == "undefined") {
    userType = systemUserUiSettings.CUSTOMER;
  }
  systemUserUiSettings.SetSessionVars(props.match.params.guid, userType);

  window.location.replace("/");
  return <div className="container">Loading...</div>;
};
